import * as Sentry from "@sentry/browser";

/** Initialise Sentry error + performance tracking (replaces the old CDN script). */
export function initSentry(): void {
  Sentry.init({
    dsn: "https://a0bc1cbff9c2450c838a75478ed062d4@o413174.ingest.sentry.io/5994462",
    release: `2048-io@${import.meta.env.VITE_APP_VERSION ?? "0.0.0"}`,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}
